import { defineMessages } from "react-intl"

export const addCustomEquipmentMessages = defineMessages({
	addCustomEquipment: {
		defaultMessage: "Add Custom Equipment",
		id: "equipment.addCustomEquipment",
	},
	customEquipmentName: {
		defaultMessage: "Equipment Name",
		id: "equipment.addCustomEquipment.customEquipmentName",
	},
	equipmentCategory: {
		defaultMessage: "Equipment Category",
		id: "equipment.addCustomEquipment.equipmentCategory",
	},
	equipmentTags: {
		defaultMessage: "Equipment Filter Criteria",
		id: "equipment.addCustomEquipment.equipmentTags",
	},
	submitCustomEquipment: {
		defaultMessage: "Add Custom Equipment",
		id: "equipment.addCustomEquipment.submitCustomEquipment",
	},
})
